import React from 'react';

/**
 * An ⓘ next to a form label that reveals an explanation.
 *
 * Focusable on purpose: a hover-only tooltip is unreachable on a phone, and the
 * aria-label carries the same text for screen readers.
 */
export default function Hint({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}): JSX.Element {
  return (
    <span className="hint" tabIndex={0} role="note" aria-label={label}>
      <span aria-hidden="true">ⓘ</span>
      <span className="hint-bubble">{children}</span>
    </span>
  );
}
